import { NgModule } from '@angular/core';

import { IconComponent } from './icon/icon.component';

const exportedDeclarations = [IconComponent];

@NgModule({
  imports: [],
  declarations: exportedDeclarations,
  exports: exportedDeclarations,
})
export class IconsModule {}
